import React from "react";
import { Award, GraduationCap, Hospital, Heart, CheckCircle2 } from "lucide-react";

export const DoctorProfile = () => {
  return (
    <section id="doctor" className="py-24 md:py-32 bg-[#FAFAF7]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5 relative">
          <div className="relative aspect-[4/5] rounded-[36px] overflow-hidden bg-[#E8F0E9] shadow-[0_30px_60px_-30px_rgba(10,41,32,0.35)]">
            <img
              src="https://www.asiandiabeticcenter.in/wp-content/uploads/2026/02/Dr.-Shalini-Patolla-Endocrinologist-in-Heyderabad.webp"
              alt="Dr. Shalini Patlolla, Senior Endocrinologist & Diabetologist, Hyderabad"
              className="h-full w-full object-cover"
            />
          </div>
          <div className="hidden md:flex absolute -right-4 -bottom-6 items-center gap-3 bg-white rounded-full border border-[#EAE7E1] pl-2 pr-5 py-2 shadow-lg">
            <span className="h-9 w-9 rounded-full bg-[#EB8771] text-white grid place-items-center">
              <Heart className="h-4 w-4" />
            </span>
            <span className="text-sm font-medium text-[#242220]">10,000+ patients treated</span>
          </div>
        </div>

        <div className="lg:col-span-7">
          <span className="inline-flex items-center gap-2 rounded-full bg-white border border-[#EAE7E1] px-3.5 py-1.5 text-xs font-semibold text-[#779D7C]">
            Meet your doctor
          </span>
          <h2 className="mt-5 font-display text-4xl md:text-5xl leading-[1.05] text-[#242220]">
            Dr. Shalini Patlolla
          </h2>
          <p className="mt-2 font-display italic text-[#779D7C] text-lg">
            Senior Consultant Endocrinologist & Diabetologist · MD, DM Endocrinology (SVIMS)
          </p>
          <p className="mt-2 text-sm text-[#6B6660]">Regd. No. 64787 · Ex‑Chief Consultant Endocrinologist, AIG Hospitals (Gachibowli)</p>
          <p className="mt-6 text-[#38312C] text-lg leading-relaxed max-w-2xl">
            Dr. Shalini is the founder of Asian Diabetes Thyroid Hormone Superspeciality Centre in
            Madinaguda, Hyderabad. She specialises in obesity medicine, diabetes, thyroid and
            hormonal disorders — combining advanced GLP‑1 therapies like <em>Mounjaro</em> with
            personalised nutrition and honest, evidence‑based care.
          </p>

          <ul className="mt-8 space-y-2.5 max-w-xl">
            {[
              "MBBS with Distinctions — Gandhi Medical College, Hyderabad",
              "MD in General Medicine — Osmania Medical College, Hyderabad",
              "DM in Endocrinology — SVIMS, Tirupati (1st rank, DM Endocrinology entrance)",
              "Published research on PCOS in Gynecological Endocrinology journal",
              "Member — Endocrine Society of India & ISPAE",
            ].map((c, i) => (
              <li key={i} className="flex items-start gap-3 text-[15px] text-[#242220]">
                <CheckCircle2 className="h-5 w-5 mt-0.5 text-[#779D7C]" strokeWidth={1.7} />
                <span>{c}</span>
              </li>
            ))}
          </ul>

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-3">
            {[
              { icon: GraduationCap, k: "MD · DM", v: "Endocrinology (SVIMS)" },
              { icon: Award, k: "10+ Years", v: "Clinical Experience" },
              { icon: Hospital, k: "Ex‑AIG", v: "Chief Consultant" },
            ].map((c, i) => (
              <div key={i} className="rounded-3xl border border-[#EAE7E1] p-6 bg-white">
                <c.icon className="h-5 w-5 text-[#EB8771]" strokeWidth={1.8} />
                <p className="font-display text-xl mt-4 text-[#242220]">{c.k}</p>
                <p className="text-sm text-[#6B6660] mt-1">{c.v}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
